import { useSelectedTournament } from '../../contexts/SelectedTournamentContext';

export const Regulations = () => {
  const { selectedTournament } = useSelectedTournament();

  if (selectedTournament && selectedTournament.regulations) {
    return (
      <>
        <p dangerouslySetInnerHTML={{ __html: selectedTournament?.regulations }}></p>
      </>
    );
  } else {
    return <>Regulamin nie został ustalony</>;
  }
};
